import { useState } from 'react';

import CouponInput from '../../Parts/CouponInput';
import Money from '../../Parts/Money';

const CouponInfo = ({
	quote, coupons, hideDeleteButtons, onCouponChange
}) => {
	const spans = coupons.map((c) => (

		<span
			key={c.ID}
			style={{
				backgroundColor: '#ffff90', display: 'inline', padding: '0.5em', display: 'inline-flex', flexDirection: 'row', justifyContent: 'space-between'
			}}
		>
			<span style={{ fontWeight: 'normal' }}>
                Coupon:&nbsp;&nbsp;
				{c.code}
			</span>
			{
				hideDeleteButtons

					? null
					: (
						<button
							style={{ backgroundColor: 'transparent', border: 'none' }}
							onClick={() => {
								const coupons = quote.addCoupon(null, () => { onCouponChange([]); });
							}}
						>
                        x
						</button>
					)
			}
		</span>
	));

	return (

		<div style={{
			display: 'flex', flexDirection: 'column', alignItems: 'right'
		}}
		>
			{spans}
		</div>

	);
};

const OrderPriceSummaryAccessoryRow = ({
	accessory, quote, multiplier
}) => (
	<tr>

		<td>{accessory.quantity}</td>
		<td>{accessory.name}</td>
		<td>
			<Money>
				{accessory.msrp * multiplier.currency_multiplier * multiplier.multiplier}
			</Money>
		</td>

	</tr>
);

const NewOrderPriceSummaryTable = (props) => {
	const {
		newQuote,
		quote,
		quoteType
	} = props;

	const [coupons, setCoupons] = useState(props.newQuote.Money.coupons);

	const fabric_sample_count = props.quote.getFabricSamplesQuantity();

	const pricing = newQuote.buy();

	const acc_rows = props.quote.accessories
		.filter((acc) => parseInt(acc.quantity) > 0)
		.map((acc) => (
			<OrderPriceSummaryAccessoryRow key={acc.id} accessory={acc} quote={props.quote} multiplier={pricing.multiplier} />
		));

	const total_oversized_fees = pricing.shipping.oversized;
	const total_outdoor_shades_shipping_price = pricing.shipping.outdoorShades;

	const total_amount_coupon = pricing.couponTotal;

	const total_shades_shipping_price = pricing.shipping.indoorShades;

	const total_accessories_shipping_price = pricing.shipping.accessories;

	const priceTitle = props.priceLabel ? props.priceLabel : 'MSRP';
	const displyPrice = pricing.assemblies;

	const couponAmount = pricing.couponTotal;
	const { subtotal } = pricing;
	const { taxes } = pricing;

	const displayTotalPrice = pricing.totalPrice;
	const displayBeforeCoupon = pricing.subtotal + total_amount_coupon;

	const putLine = displayBeforeCoupon != displayTotalPrice && taxes > 0;

	const demo = newQuote.GetDemoInfo();
    
	const isDemo = newQuote.IsDemo;

	let newDisplayTotalPrice = null;

	let demoDiscount = null;
	if (isDemo) {
		newDisplayTotalPrice = (demo?.demoApprovalType?.name != 'cash' ? subtotal * (1 - demo.value / 100) : demo.value);
		demoDiscount = newDisplayTotalPrice - displayTotalPrice;
	}

	return (

		<div>

			<table className={`order-confirmation-table ${quoteType}`} border="0" cellSpacing="0" cellPadding="0">
				<tbody>

					<tr className="bold-row">
						<th>Qty</th>
						<th>Product</th>
						<th>{priceTitle}</th>
					</tr>

					<tr>

						<td>{quote.getShadeCount()}</td>

						<td>Shades</td>

						<td>
							<Money>{displyPrice}</Money>
						</td>

					</tr>

					<tr>

						<td>1</td>

						<td>Shades Shipping</td>

						<td>
							<Money>{total_shades_shipping_price}</Money>
						</td>

					</tr>

					{acc_rows}

					{
						total_accessories_shipping_price

							? (
								<tr>

									<td>1</td>

									<td>Accessories Shipping</td>

									<td>
										<Money>{total_accessories_shipping_price}</Money>
									</td>

								</tr>
							)
							: null
					}

					{
						total_oversized_fees > 0
							? (
								<tr>
									<td>1</td>
									<td>Oversized Shipping Fee</td>
									<td>
										<Money>{total_oversized_fees}</Money>
									</td>
								</tr>
							)
							: null
					}

					{
						total_outdoor_shades_shipping_price > 0
							? (
								<tr>
									<td>1</td>
									<td>Outdoor Shades Freight</td>
									<td>
										<Money>{total_outdoor_shades_shipping_price}</Money>
									</td>
								</tr>
							)
							: null
					}

					{
						fabric_sample_count > 0
							? (
								<tr>
									<td>{fabric_sample_count}</td>
									<td>Fabric Samples</td>
									<td><Money>{0}</Money></td>
								</tr>
							)
							: null
					}

				</tbody>
			</table>

			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<div style={{ flexGrow: '1' }}>

					{
						props.couponsEditable && !isDemo
							? (
								<CouponInput
									quote={props.quote}
									quoteType={quoteType}
									onCouponChange={(coupons) => { setCoupons(coupons); }}
								/>
							)
							: null
					}

					<div style={{ width: '100%', height: '9px' }} />

					<CouponInfo
						quoteType={quoteType}
						quote={props.quote}
						hideDeleteButtons={!(props.couponsEditable && !isDemo)}
						coupons={coupons}
						onCouponChange={(coupons) => { setCoupons(coupons); }}
					/>

				</div>

				<div style={{
					display: 'flex', flexDirection: 'column', textAlign: 'right', marginLeft: '2.25em'
				}}
				>

					{
						total_amount_coupon
							? (
								<>
									<span>
										{total_amount_coupon ? '' : 'Total'}
Price:&nbsp;&nbsp;
										<Money>{displayBeforeCoupon}</Money>
									</span>

									<span>
                                    Discount:&nbsp;&nbsp;
										<span style={{ color: 'red' }}>
                                        -
											<Money>{total_amount_coupon}</Money>
										</span>
									</span>

								</>
							)
							: null
					}

					{(putLine)
						? (
							<span style={{ flexGrow: '1' }}>
								<div>
                                Subtotal:
									{' '}
									<Money>{subtotal}</Money>
								</div>

								<div>
                                Taxes :
									{' '}
									<Money>{taxes}</Money>
								</div>
							</span>
						)
						: null}

					{
						putLine ? <hr style={{ width: '100%' }} /> : null
					}

					<span className="total-price-text right-align">
                        Total:&nbsp;&nbsp;
						<Money>{displayTotalPrice}</Money>
					</span>
					{isDemo ? (
						<>
							<span className="total-price-text right-align">
                        Demo Discount:&nbsp;&nbsp;
								<Money>{demoDiscount}</Money>
							</span>
							<span className="total-price-text right-align">
                        Demo Total:&nbsp;&nbsp;
								<Money>{newDisplayTotalPrice}</Money>
							</span>
						</>
					) : null}
				</div>

			</div>

		</div>
	);
};

export default NewOrderPriceSummaryTable;
